import { InfoCircleTwoTone } from "@ant-design/icons";
import { Box, Button, useTheme } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { Text } from "@src/lib/ui-react";
import { Link as RouterLink } from "react-router-dom";

interface PlacementReviewBannerProps {
  candidateCount: number;
}

export function PlacementReviewBanner({ candidateCount }: PlacementReviewBannerProps) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        backgroundColor: alpha(theme.palette.error.main, 0.1),
        padding: theme.spacing(1, 2),
        border: `1px solid ${alpha(theme.palette.error.main, 0.3)}`,
        borderRadius: theme.spacing(1.5),
        width: "fit-content",
        margin: theme.spacing(0, 0, 2, 2),
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(1.5),
      }}
    >
      <InfoCircleTwoTone twoToneColor={theme.palette.error.main} />
      <Text variant="body2" sx={{ color: theme.palette.error.main, padding: theme.spacing(0, 1) }}>
        <Box component="span" sx={{ fontWeight: "bold" }}>
          {candidateCount}
        </Box>{" "}
        Candidates are awaiting your review. Please review them now and choose to request an
        interview or decline.
      </Text>
      <Button
        component={RouterLink}
        to="/workplace/manage-jobs?tab=applicants"
        variant="outlined"
        color="error"
        size="small"
        sx={{
          textTransform: "none",
          fontWeight: 600,
          borderColor: theme.palette.error.main,
          color: theme.palette.error.main,
          "&:hover": {
            color: theme.palette.getContrastText(theme.palette.background.default),
            borderColor: theme.palette.background.default,
            backgroundColor: theme.palette.background.default,
          },
        }}
      >
        View candidates
      </Button>
    </Box>
  );
}
